export async function tokenResult(user) {
  const idTokenResult = await user.getIdTokenResult();
  return idTokenResult;
}
